import { cooperationTypes } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function CooperationTypes() {
  return (
    <section id="types" className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="Cooperation Types"
            title="五类合作方式"
            description="每种合作方式都对应不同的边界与产出形式。请在申请时说明希望采用哪一种，我们会据此安排对接。"
          />

          <div className="mt-10 md:mt-12 border-t border-foreground-950/10">
            {cooperationTypes.map((type, index) => (
              <article
                key={type.title}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-8 py-7 md:py-9 border-b border-foreground-950/10"
              >
                <div className="lg:col-span-1 flex items-center gap-4 lg:block">
                  <span className="font-mono text-xs text-primary-500">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50 border border-foreground-950/10 text-foreground-900 group-hover:bg-foreground-950 group-hover:text-background-50 group-hover:border-foreground-950 transition-colors lg:mt-4">
                    <i className={`${type.icon} text-xl`}></i>
                  </span>
                </div>

                <div className="lg:col-span-4">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {type.title}
                  </h3>
                </div>

                <div className="lg:col-span-7">
                  <p className="text-sm md:text-base leading-relaxed text-foreground-600">
                    {type.desc}
                  </p>
                  <ul className="mt-4 flex flex-wrap gap-2">
                    {type.points.map((point) => (
                      <li
                        key={point}
                        className="inline-flex items-center gap-1.5 bg-background-50 border border-foreground-950/10 rounded-full px-3 py-1.5 text-xs text-foreground-700"
                      >
                        <i className="ri-check-line text-secondary-500"></i>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}